import React from "react"

import BaseSvgIcon from "../Base"

const Cart = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 32 28">
    <path
      d="M1.63951 0C0.915489 0 0.333008 0.567424 0.333008 1.27273C0.333008 1.97803 0.915489 2.54545 1.63951 2.54545H4.10553C4.31784 2.54545 4.49748 2.69394 4.53558 2.89545L7.37178 18.078C7.70929 19.8917 9.33153 21.2121 11.226 21.2121H25.1565C25.8805 21.2121 26.463 20.6447 26.463 19.9394C26.463 19.2341 25.8805 18.6667 25.1565 18.6667H11.226C10.5945 18.6667 10.0556 18.2265 9.94123 17.622L9.6636 16.1212H26.1908C27.8675 16.1212 29.3047 14.9598 29.615 13.353L31.3025 4.5553C31.5039 3.51061 30.6819 2.54545 29.5877 2.54545H7.12137L7.09959 2.43939C6.83829 1.02879 5.57534 0 4.10008 0H1.63951ZM11.656 28C13.0986 28 14.269 26.8598 14.269 25.4545C14.269 24.0492 13.0986 22.9091 11.656 22.9091C10.2134 22.9091 9.04301 24.0492 9.04301 25.4545C9.04301 26.8598 10.2134 28 11.656 28ZM23.85 28C25.2926 28 26.463 26.8598 26.463 25.4545C26.463 24.0492 25.2926 22.9091 23.85 22.9091C22.4074 22.9091 21.237 24.0492 21.237 25.4545C21.237 26.8598 22.4074 28 23.85 28Z"
      fill="black"
    />
  </BaseSvgIcon>
)

export default Cart
